module.exports = __webpack_public_path__ + "static/media/53010624_2452986211443222_6869847533376503808_o.fe286c3b.jpg";